import React from 'react';
import PropTypes from 'prop-types';

class Type extends React.Component {
    render() {
        const { type, isLoading } = this.props;

        if (isLoading || !type) {
            return null;
        }

        // Il faut éventuellement ajouter un format.

        return type.libelle;
    }
}

Type.propTypes = {
    type: PropTypes.object,
    isLoading: PropTypes.bool.isRequired
};

export default Type;